import axios from "axios"
import { API_URL, getHeader } from "../config"

export const getHighlight = async () => {
    const { data } = await axios.get(API_URL + `/api/highlight/LVISGURGAON`);
    console.log(data)
    return data;
}
export const getBirthdays = async () => {
    const { data } = await axios.get(API_URL + `/api/birthdays/LVISGURGAON`);
    return data;
}
export const getNews = async () => {
    console.log("first")
    const { data } = await axios.get(API_URL + `/api/news/LVISGURGAON`);
    console.log("news:", data)
    return data;
}
export const getNewsInner = async ({limit="10", year="", page=""}) => {
    console.log("first")
    const { data } = await axios.get(API_URL + `/api/news/all/limit/LVISGURGAON?limit=${limit}&page=${page}&year=${year}`);
    console.log("news:", data)
    return data;
}
export const form = async (formData, header, type) => {
    try {
        const { data } = await axios.post(`${API_URL}/api/form/LVISGURGAON/${type}`, formData, header);
        return data;
    } catch (error) {
        console.error('Error in form submission:', error);
        if (error.response) {
            console.error('Error response data:', error.response.data); 
        }
        throw error;
    }
};


export const getEvents = async () => {
    const { data } = await axios.get(API_URL + `/api/events/LVISGURGAON`);
    console.log("getEvents", data)
    return data;
}

export const getEventsinner = async () => {
    const { data } = await axios.get(API_URL + `/api/events/All/LVISGURGAON`);
    console.log(data)
    return data;
}

export const getGallery = async () => {
    const { data } = await axios.get(API_URL + `/api/gallery/LVISGURGAON`);
    return data;
}

// export const getGalleryInner = async () => {
//     const { data } = await axios.get(API_URL + `/api/gallery/All/LVISGURGAON`);
//     return data;
// }


export const getGalleryInner = async ({limit="10000", year="", page=""}) => {
    console.log("Gallery")
    const { data } = await axios.get(API_URL + `/api/gallery/all/limit/LVISGURGAON?limit=${limit}&page=${page}&year=${year}`);
    console.log("Gallery:", data)
    return data;
}



export const getSubGallery = async (id) => {
    console.log(id)
    const { data } = await axios.get(API_URL + `/api/subGallery?id=${id}`);
    console.log(data)
    return data;
}

export const getNotification = async () => {
    const { data } = await axios.get(API_URL + `/api/notification/LVISGURGAON`, getHeader());
    return data;
}

export const getTopper = async () => {
    const { data } = await axios.get(API_URL + `/api/topper/LVISGURGAON`, getHeader());
    return data;
}

export const getOnlineRegistration = async () => {
    const { data } = await axios.get(API_URL + `/api/onlineRegistration/LVISGURGAON`, getHeader());
    console.log("online registration Data", data)
    return data;
}

export const getSliders = async () => {
    const { data } = await axios.get(API_URL + `/api/slider/LVISGURGAON`, getHeader());
    return data;
}

export const getPrincipalMessage = async () => {
    const { data } = await axios.get(API_URL + `/api/principalMessage/LVISGURGAON`, getHeader());
    console.log(data)
    return data;
}

export const getMedia = async () => {
    const { data } = await axios.get(API_URL + `/api/media/LVISGURGAON`, getHeader());
    console.log(data);
    return data;
}
export const getVideoGallery = async () => {
    const { data } = await axios.get(API_URL + `/api/video/all/LVISGURGAON`, getHeader());
    return data;
}
export const getCircular = async () => {
    const { data } = await axios.get(API_URL + `/api/circular/all/LVISGURGAON`, getHeader());
    console.log(data);
    return data;
}
export const getReading = async () => {
    const { data } = await axios.get(API_URL + `/api/reading/all/LVISGURGAON`, getHeader());
    console.log(data);
    return data;
}
export const getFaculty = async () => {
    const { data } = await axios.get(API_URL + `/api/faculty/all/LVISGURGAON`, getHeader());
    console.log(data);
    return data;
}

export const academicCalender = async () => {
    const { data } = await axios.get(API_URL + `/api/academicCalender/all/LVISGURGAON`, getHeader());
    console.log("academic calender", data)
    return data;
}
export const postTransferCertificate = async (name, admission) => {
    console.log(name, admission)
    const { data } = await axios.post(API_URL + `/api/tc/LVISGURGAON`, { name, admission }, getHeader());
    return data;
}